/**
 * The kicker (small label) and title (large heading) of every tab and page that
 * opens with a SectionHeader. They live here so the wording can be changed in one
 * place, and so a title says what the section is: a first-time visitor should not
 * have to decode it.
 *
 * Titles are plain strings. SectionHeader still accepts a node for a title that
 * wants an emphasised word, but nothing here needs one.
 */
export const SECTION_TITLES = {
  myEvents: { kicker: "My events", title: "Your events" },
  browseEvents: { kicker: "All events", title: "What is on" },
  speakers: { kicker: "Speakers", title: "Who is speaking" },
  attendees: { kicker: "Attendees", title: "Who is here" },
  venues: { kicker: "Venues", title: "Venues and directions" },
  partners: { kicker: "Partners", title: "Our partners" },
  info: { kicker: "Info", title: "Practical information" },
  resources: { kicker: "Resources", title: "Documents and links" },
  highlights: { kicker: "Highlights", title: "Key sessions" },
} as const;

export type SectionKey = keyof typeof SECTION_TITLES;
